import script from "./app-accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./app-accordion.vue?vue&type=script&setup=true&lang=js"

import "./app-accordion.vue?vue&type=style&index=0&id=0680b1e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0680b1e6"]])

export default __exports__